module.exports = __webpack_public_path__ + "img/Teacher.d15881ef.jpg";